import { InjectionToken } from '@angular/core';
import { Focusable } from '@portal-core/ui/focus/interfaces/focusable';

export const MC_FOCUSABLE = new InjectionToken<Focusable>('MCFocusableToken');
